function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd",
  opacity: .5,
  transform: "translate(-8 -7)"
}, React.createElement("rect", {
  width: 15,
  height: 11,
  x: 8,
  y: 13
}), React.createElement("path", {
  fillRule: "nonzero",
  d: "M18,14 L18,12.5 C18,11.1192881 16.8807119,10 15.5,10 C14.1192881,10 13,11.1192881 13,12.5 L13,14 L18,14 Z M15.5,7 C18.5375661,7 21,9.46243388 21,12.5 L21,17 L10,17 L10,12.5 C10,9.46243388 12.4624339,7 15.5,7 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/locked.9ddf1816.svg";
export { SvgComponent as ReactComponent };